/*
 * @Descripttion:
 * @version:
 * @Author: sujun
 * @email: 1373842098@qq.com
 * @Date: 2022-01-04 11:12:46
 * @LastEditors: linxi
 * @LastEditTime: 2025-05-23 14:58:08
 */
import { Col } from 'antd'
import React, { ReactElement, useEffect, useState } from 'react'
import { TabBar, TabPane } from '../../compnents/widgets/TabBar'
import { ReplaceMakeDetail } from './detail/ReplaceMakeDetail'
import { ReplaceMakeOrder } from './order/ReplaceMakeOrder'
import { ReplaceMakePrice } from './price/Price'
import { ReplaceMakeRecipeDetail } from './recipeDetail/RecipeDetail'
import { ReplaceMakeOrderTabs } from './ReplaceMakeOrderTabs/ReplaceMakeOrderTabs'
import { ReplaceMakeAStatistics } from './statistics/statistics'
import { useSelector } from 'react-redux'
import { selectTwoMenus } from '../../layouts/layoutSlice'

export const OReplaceNavBar = (): ReactElement => {
  const [tabSelect, setTabSelect] = useState<any>('0')

  const twoMenus = useSelector(selectTwoMenus)

  const menuList = twoMenus?.filter((v) => {
    return v?.name == '代煎'
  })?.[0]


  const getKeys = (i: string) => {
    switch (i) {
      case '代煎订单':
        return '0'
      case '代煎目录价格表':
        return '1'
      case '代煎明细查询':
        return '2'
      case '代煎处方明细':
        return '4'
      case '代煎统计':
        return '3'
      default:
        return '-'
    }
  }

  useEffect(() => {
    setTabSelect(tabSelect || getKeys(menuList?.subMenus?.[0]?.name))
  }, [tabSelect])
  
  return (
    <Col
      style={{
        display: 'flex',
        position: 'relative',
        flexDirection: 'column',
        height: '100%',
        overflowY: 'hidden',
      }}
    >
      <TabBar
        style={{ margin: '10px 20px' }}
        onChange={(v) => {
          setTabSelect(v)
        }}
      >
        {menuList?.subMenus?.map((v: any) => {
          return (
            <>
              <TabPane key={getKeys(v?.name)} tab={v?.name} style={{ height: '100%' }}>
                {v?.name == '代煎订单' ? (
                  <ReplaceMakeOrderTabs />
                ) : v?.name == '代煎目录价格表' ? (
                  <ReplaceMakePrice />
                ) : v?.name == '代煎明细查询' ? (
                  <ReplaceMakeDetail />
                ) : v?.name == '代煎处方明细' ? (
                  <ReplaceMakeRecipeDetail />
                ) : v?.name == '代煎统计' ? (
                  <ReplaceMakeAStatistics tabSelect={tabSelect} />
                ) : null}
              </TabPane>
            </>
          )
        })}
      </TabBar>
    </Col>
  )
}
